export default __webpack_public_path__ + "/dist/images/search-recipe-icon.95528ef1e3d7e2e6a209c9b15369c249.svg";